import { render, staticRenderFns } from "./huishou.vue?vue&type=template&id=6ababfb2&scoped=true&"
import script from "./huishou.vue?vue&type=script&lang=js&"
export * from "./huishou.vue?vue&type=script&lang=js&"
import style0 from "./huishou.vue?vue&type=style&index=0&id=6ababfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ababfb2",
  null
  
)

export default component.exports